module.exports = __webpack_public_path__ + "static/assets/87f09da725b51a5a735a2f523a5a1a14.png";